'use client';

import { LeadBarItem } from './LeadBarItem';
import { ESTIMATE_HREF, openDefaultConsultPopup } from './leadActions';

type Props = {
  /** 오피스 견적 버튼 노출. */
  showEstimate?: boolean;
  /** 상담 신청 버튼 노출. */
  showConsult?: boolean;
  /** 상담 신청 액션. 없으면 리드폼 팝업(탭형) 오픈. */
  consultAction?: () => void;
};

/**
 * 모바일 전용 하단 고정 리드 바 (PC 는 `<LeadButton />` 세로 레일).
 * 전화 항목은 모바일에서 노출하지 않는다 — GNB 의 「전화 상담」 버튼이 대체한다.
 */
export function LeadBar({
  showEstimate = false,
  showConsult = false,
  consultAction,
}: Props) {
  if (!showEstimate && !showConsult) return null;

  return (
    <div className="shadow-500 desktop:hidden flex h-56 w-full overflow-hidden">
      {showEstimate && (
        <LeadBarItem
          label="오피스 견적 확인"
          iconType="estimate"
          tone="primary"
          href={ESTIMATE_HREF}
        />
      )}
      {showConsult && (
        <LeadBarItem
          label="상담 신청"
          iconType="counsel"
          tone="plain"
          onClick={consultAction ?? openDefaultConsultPopup}
        />
      )}
    </div>
  );
}
